import eventHub from '@/scripts/eventHub';
import store from '@/store';
import vars from './vars';

const state = {
  maxLife: 3,
  _points: 0,
  _hitCounter: 0,
  rayActive: false,
  _meters: 0,
  _level: 1,
  _stopped: true,
  _gameover: false,
  currentLightFrame: 0, // Used to sync ray and circle on the ground

  // Params modified by powerups
  poppingSpeed: 0.05,
  rayWide: 1,
  rayFar: 1,

  hasActivePowerUp: false,
  _powerUpProgress: 0,

  // Lerping params
  delayFunction: (a, b, n) => ((1 - n) * a) + (n * b),
  delayFactor: 0.95,

  // Difficulty params (start)
  speed: 1.8,
  spawnDelay: 1200,
  flowerShif: 'none',

  get currentLife() { return state.maxLife - state.hitCoutner; },
  get points() { return this._points; },
  set points(val) {
    this._points = val;
    console.log('Points: ', this.points);
    store.commit('SET_SCORE', this.points);
  },
  get hitCounter() { return state._hitCounter; },
  set hitCounter(val) {
    state._hitCounter = val;
    eventHub.$emit('hit');
    console.log('Hit taken: ', state.hitCounter);
    store.commit('SET_LIFE', state.maxLife - state._hitCounter);
    if (state.hitCounter > state.maxLife) {
      eventHub.$emit('gameover');
    }
  },
  get meters() { return this._meters; },
  set meters(value) {
    this._meters = value;
    store.commit('SET_MT', state._meters);
  },
  get powerUpProgress() { return this._powerUpProgress; },
  set powerUpProgress(value) {
    this._powerUpProgress = value;
    store.commit('SET_POWER_UP_PERCENTAGE', this._powerUpProgress);
  },
  get level() { return this._level; },
  set level(value) {
    this._level = value;
    const l = vars.levels.get(value);
    if (typeof l !== 'undefined') { // Before max level
      this.spawnDelay = l.spawnDelay;
      this.speed = l.speed;
      this.flowerShif = l.flowerShift;
    }
    store.commit('SET_LEVEL', state._level);
  },
  get stopped() { return this._stopped; },
  set stopped(value) {
    this._stopped = value;
    store.commit('SET_PLAY_GAME', state._stopped);
  },
  get gameover() { return this._stopped; },
  set gameover(value) {
    this._gameover = value;
    store.commit('SET_GAMEOVER', state._gameover);
  },

  reset() {
    this.hitCounter = 0;
    this.level = 1;
    this.points = 0;
    this.meters = 0;
    this.hasActivePowerUp = false;
    this.powerUpProgress = 0;
    this.currentLightFrame = 0;
    eventHub.$emit('reset-hit');
  },
};

export default state;
